/**
 * Formats a FHIR month code (e.g., "P2M" or "P02M") to a display number (e.g., "2")
 * @param monthCode - The FHIR month code (e.g., "P2M" or "P02M")
 * @returns The month number as a string (e.g., "2")
 */
export const formatFHIRMonthCode = (monthCode?: string): string => {
  if (!monthCode) return '';
  return monthCode.replace('P', '').replace('M', '').replace(/^0+/, '');
};
